/**
 * Six shapes, one per kid in the order they were added, so the graph's lines are told apart by
 * more than colour. Sides 0 is a circle; `turn` rotates the first corner (degrees).
 */
const SHAPES = [
  { sides: 0, turn: 0 },
  { sides: 4, turn: 45 },
  { sides: 3, turn: -90 },
  { sides: 4, turn: 0 },
  { sides: 3, turn: 90 },
  { sides: 6, turn: 0 },
];

/** A kid's shape at cx, cy for use inside an SVG; styled by `className`. */
export function MarkerShape({
  shape,
  cx,
  cy,
  r,
  className,
}: {
  shape: number;
  cx: number;
  cy: number;
  r: number;
  className?: string;
}) {
  const s = SHAPES[shape % SHAPES.length];
  if (s.sides === 0) return <circle className={className} cx={cx} cy={cy} r={r} />;
  // A polygon looks smaller than a circle of the same radius, so its corners reach a little further.
  const reach = r * (s.sides === 3 ? 1.4 : 1.25);
  const points = Array.from({ length: s.sides }, (_, k) => {
    const a = ((s.turn + (k * 360) / s.sides) * Math.PI) / 180;
    return `${(cx + reach * Math.cos(a)).toFixed(1)},${(cy + reach * Math.sin(a)).toFixed(1)}`;
  }).join(" ");
  return <polygon className={className} points={points} />;
}

/** The kid's shape in their colour (--kid), inline with text: the graph's legend and readout. */
export function KidMarker({ shape }: { shape: number }) {
  return (
    <svg className="kid-marker" viewBox="-7 -7 14 14" width="13" height="13" aria-hidden="true" focusable="false">
      <MarkerShape shape={shape} cx={0} cy={0} r={5} />
    </svg>
  );
}
